export default "__VITE_ASSET__fefj6w23__"